export const formatNumber = (num: number | undefined): string => {
    if (num) {
        return '$ ' + num.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
    }

    return '$ 0';
};
